import { render, staticRenderFns } from "./updatepopup.vue?vue&type=template&id=27f08f1b&"
import script from "./updatepopup.vue?vue&type=script&lang=js&"
export * from "./updatepopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports